// extracted by mini-css-extract-plugin
export default {"link":"_-_-record-it-components-src-cardList-CardListItemIconLink-__link"};